import { render, staticRenderFns } from "./FormImportList.vue?vue&type=template&id=39d6ba82&scoped=true"
import script from "./FormImportList.vue?vue&type=script&lang=js"
export * from "./FormImportList.vue?vue&type=script&lang=js"
import style0 from "./FormImportList.vue?vue&type=style&index=0&id=39d6ba82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6ba82",
  null
  
)

export default component.exports